// extracted by mini-css-extract-plugin
export default {"meetingType_details_guestList":"guestList-module__meetingType_details_guestList___PtDL0"};